/** Envelope returned by every Fair Doctor API endpoint. `statusCode` "10000" means success. */
export interface ApiEnvelope<T> {
  statusCode: string;
  message: string;
  data?: T;
}

export const API_SUCCESS_CODE = '10000';
